/* Search uses the same catalog cutouts as product cards, only for this store. */
(() => {
  const config = window.IllegalShirts || {};
  const origin = location.origin;
  const storeHosts = new Set(['shopillegalshirts.com', 'www.shopillegalshirts.com', 'polandshirts.myshopify.com']);
  let imageMap = {};
  let mapReady;
  const ready = () => mapReady ||= (async () => {
    if (!config.product_image_map) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 1800);
    try {
      const response = await fetch(config.product_image_map, { signal: controller.signal });
      if (response.ok) imageMap = await response.json();
    } catch (_) { /* New images can still use the storefront proxy. */ }
    finally { clearTimeout(timeout); }
  })();
  function eligible(source, options = {}) {
    if (options.external || !options.productUrl) return false;
    try {
      const product = new URL(options.productUrl, origin);
      const image = new URL(source, origin);
      if (!storeHosts.has(product.hostname) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(product.pathname) || /custom/i.test(product.pathname)) return false;
      if (!['https:', 'http:'].includes(image.protocol) || /\/uploads\//i.test(image.pathname)) return false;
      return (image.hostname === 'cdn.shopify.com' && image.pathname.startsWith('/s/files/1/0555/6643/4592/files/')) ||
        (storeHosts.has(image.hostname) && image.pathname.startsWith('/cdn/shop/files/'));
    } catch (_) { return false; }
  }
  function url(source, width = 640, options = {}) {
    if (!source || !eligible(source, options)) return source || '';
    const original = new URL(source, origin);
    let filename;
    try { filename = decodeURIComponent(original.pathname.split('/').pop()); } catch (_) { return source; }
    const asset = imageMap[filename];
    if (typeof asset === 'string' && config.product_asset_base) {
      const name = width <= 400 && /^cutout-\d+\.webp$/.test(asset) ? asset.replace(/\.webp$/, '-400.webp') : asset;
      return new URL(name, new URL(config.product_asset_base, origin)).href;
    }
    original.searchParams.set('width', String(width));
    return '/apps/illegal-cutouts/image?src=' + encodeURIComponent(original.href) + '&w=' + width + '&cv=6';
  }
  function apply(image, source, width, options) {
    const processed = eligible(source, options);
    image.addEventListener('error', () => {
      image.removeAttribute('srcset');
      if (processed) image.src = source;
    }, { once: true });
    if (processed) {
      image.style.objectFit = 'contain';
      image.srcset = `${url(source, 320, options)} 320w, ${url(source, 640, options)} 640w`;
    }
    image.src = url(source, width, options);
    return image;
  }
  window.IllegalProductImages = { ready, url, apply, eligible };
})();
